import axios from "axios";
import { loginreq, req, reqPost } from "./axiosFun";

// 家教报名记录
export const tutoringRecordsApi = params => {
    return axios
        .get(
            `http://118.195.249.109:446/app-yijiu-backstage/geTutorApplicationList?token=${localStorage.getItem(
                "logintoken"
            )}&name=${params.name}&page=${params.page}&phone=${params.phone}&startTime=${params.startTime}&endTime=${params.endTime}`,
            params
        )
        .then(res => res.data);
};


// 家长报名记录 
export const parentRecordsApi = params => {
    return axios
        .get(
            `http://118.195.249.109:446/app-yijiu-backstage/getTutorRequirementList?token=${localStorage.getItem(
                "logintoken"
            )}&name=${params.name}&page=${params.page}&phone=${params.phone}&startTime=${params.startTime}&endTime=${params.endTime}`,
            params
        )
        .then(res => res.data);
};
// 充值记录
export const rechargeRecordsApi = params => {
    return axios
        .get(
            `http://118.195.249.109:446/app-yijiu-backstage/getTutorRechargeRecordList?token=${localStorage.getItem(
                "logintoken"
            )}&nickName=${params.nickName}&page=${params.page}&mobile=${params.mobile}&rechargeNo=${params.rechargeNo}&startTime=${params.startTime}&endTime=${params.endTime}`,
            params
        )
        .then(res => res.data);
};
// 导出家教报名
export const exportTutoringApi = params => {
    return req("get", "/app-yijiu-backstage/exportTutorApplicationExcel", params);
};
// 导出家长报名
export const exportParentApi = params => {
    return req("get", "/app-yijiu-backstage/exportTutorRequirementExcel", params);
};
// 导出充值记录
export const exportRechargeApi = params => {
    return axios
    .get(
        `http://118.195.249.109:446/app-yijiu-backstage/exportRechargeRecordListExcel?token=${localStorage.getItem(
            "logintoken"
        )}&nickName=${params.nickName}&page=${params.page}&mobile=${params.mobile}&rechargeNo=${params.rechargeNo}`,
        params
    )
    .then(res => res.data);
};


// WEBPACK FOOTER //
// ./src/api/registration.js